import React, { useEffect, useRef, useState } from 'react';
import CustomText from '../../../../Common/customComponents/CustomText.tsx';
import { TextButton } from '../../../../../components';
import ButtonInnerX from '/assets/icon/global/button-inner-x.svg';
import UserSearchModal from '../../../Setting/modal/UserSearchModal.tsx';
import FormApprovalRow from './FormApprovalRow.tsx';
import FormApprovalRowForExtend from './FormApprovalRowForExtend.tsx';

interface IProps {
  data: any;
  setData: any;
  handleChange?: any;
  formCode?: string;
  isReadOnly: boolean;
  onRefresh?: () => void;
  isFinish: boolean;
}

const FormApproval = (props: IProps) => {
const [initCloneData, setInitCloneData] = useState<any>(null);

  //reset을 위해 초기 값 저장
  useEffect(() => {
    if (!initCloneData && props.data?.approvalMVOList) {
      setInitCloneData(JSON.parse(JSON.stringify(props.data.approvalMVOList)));
    }
  }, [props.data]);

  const getApprovalKey = (item: any): number | null => {
    return item?.approvalMSeq ?? item?.settingApprovalModeSeq ?? null;
  };

  const onRefresh = () => {
    props.onRefresh?.();
  };

  useEffect(() => {
    console.log(
      'props.data?.approvalMVOList',
      props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'CLOSURE')
    );
  }, [props.data?.approvalMVOList]);

  return (
    <div>
      {props.data?.approvalMVOList &&
        props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'ISSUE').length >
          0 && (
          <div className={'approval-area'}>
            <div className={'approval-header'}>
              <span className={'header-title'}>* Issue Open</span>
            </div>
            <div className={'approval-body'}>
              <table className={'form-table'}>
                <tbody>
                  {props.data?.approvalMVOList &&
                    props.data?.approvalMVOList
                      .filter((item: any) => item.approvalType == 'ISSUE')
                      .map((approverItem: any, approverIndex: number) => (
                        <FormApprovalRow
                          key={getApprovalKey(approverItem) ?? approverIndex}
                          type={'ISSUE'}
                          approverItem={approverItem}
                          data={props.data}
                          setData={props.setData}

                          isReadOnly={props.isReadOnly}
                          isFinish={props.isFinish}
                        />
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      {props.data?.approvalMVOList &&
        props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'DAILY').length >
          0 && (
          <div className={'approval-area'}>
            <div className={'approval-header'}>
              <span className={'header-title'}>* Daily Approval</span>
            </div>
            <div className={'approval-body'}>
              <table className={'form-table'}>
                <tbody>
                  {props.data?.approvalMVOList &&
                    props.data?.approvalMVOList
                      .filter((item: any) => item.approvalType == 'DAILY')
                      .map((approverItem: any, approverIndex: number) => (
                        <FormApprovalRow
                          key={getApprovalKey(approverItem) ?? approverIndex}
                          type={'DAILY'}
                          approverItem={approverItem}
                          data={props.data}
                          setData={props.setData}

                          isReadOnly={props.isReadOnly}
                          isFinish={props.isFinish}
                        />
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      {/*EXTEND 추가*/}
      {props.data?.approvalMVOList &&
        props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'EXTEND').length >
          0 && (
          <div className={'approval-area'}>
            <div className={'approval-header'}>
              <span className={'header-title'}>Extend Approval</span>
            </div>
            <div className={'approval-body'}>
              <table className={'form-table'}>
                <tbody>
                  {props.data?.approvalMVOList &&
                    props.data?.approvalMVOList
                      .filter((item: any) => item.approvalType == 'EXTEND')
                      .map((approverItem: any, approverIndex: number) => (
                        <FormApprovalRow
                          key={getApprovalKey(approverItem) ?? approverIndex}
                          type={'EXTEND'}
                          approverItem={approverItem}
                          data={props.data}
                          setData={props.setData}

                          isReadOnly={props.isReadOnly}
                          onRefresh={onRefresh}
                          isFinish={props.isFinish}
                        />
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

      {props.data?.approvalMVOList &&
        props.data?.approvalMVOList?.filter((item: any) => item.approvalType == 'CLOSURE').length >
          0 && (
          <div className={'approval-area'}>
            <div className={'approval-header'}>
              <span className={'header-title'}>* Closing Approval</span>
            </div>
            <div className={'approval-body'}>
              <table className={'form-table'}>
                <tbody>
                  {props.data?.approvalMVOList &&
                    props.data?.approvalMVOList
                      .filter((item: any) => item.approvalType == 'CLOSURE')
                      .map((approverItem: any, approverIndex: number) => (
                        <FormApprovalRow
                          key={getApprovalKey(approverItem) ?? approverIndex}
                          type={'CLOSURE'}
                          approverItem={approverItem}
                          data={props.data}
                          setData={props.setData}

                          isReadOnly={props.isReadOnly}
                          onRefresh={onRefresh}
                          isFinish={props.isFinish}
                        />
                      ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
    </div>
  );
};

export default FormApproval;
